var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-2"},[(_vm.$apollo.loading)?_c('loader'):_c('div',_vm._l((this.tree.children),function(child,i){return _c('tocitem',{key:i,attrs:{"provision":child,"slug":_vm.slug,"expanded":true}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }